import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'selector-fecha',
  templateUrl: './selector-fecha.component.html',
  styleUrls: ['./selector-fecha.component.scss']
})
export class SelectorFechaComponent implements OnInit {

  @Input() form;
  @Input() id: string;
  @Input() label: string;
  // @Input() disabled: boolean;

  constructor() { }

  ngOnInit(): void {
  }


}
